import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  Avatar,
  IconButton,
  Tooltip,
  Hidden,
} from '@material-ui/core'
import { read } from 'actions/data'
import {
  toggleContactViewPanel,
  toggleChatSearch,
  handleSearchOptionsChange,
  toggleThreadView,
  selectConversation,
} from 'actions/inbox'
import Button from 'components/theme/Button'
import {
  RemoveRedEye,
  Person,
  Search,
  KeyboardArrowLeft,
  // Refresh,
} from '@material-ui/icons'
import SearchOptionsMenu from './SearchOptionsMenu'
import { Fragment } from 'react'

const SummaryAvatar = connect(
  (state) => ({
    first: state.addOrEditContact.fields.first_name.value,
    last: state.addOrEditContact.fields.last_name.value,
  }),
  null,
)(
  withStyles((theme) => ({
    avatarRoot: {
      width: 60,
      height: 60,
      fontSize: 20,
      borderRadius: 15,
      color: '#fff',
      backgroundColor: '#13b940',
    },
    avatar: {
      position: 'absolute',
      left: 15,
      top: '7.5px',
      [theme.breakpoints.down('sm')]: {
        left: 28,
      },
    },
  }))(({ first, last, classes }) => (
    <Avatar className={classes.avatar} classes={{ root: classes.avatarRoot }}>
      {first || last ? (
        `${first ? `${first.slice(0, 1)}` : ''}${
          last ? `${last.slice(0, 1)}` : ''
        }`
      ) : (
        <Person />
      )}
    </Avatar>
  )),
)

const SummaryName = connect(
  (state) => ({
    first: state.addOrEditContact.fields.first_name.value,
    middle: state.addOrEditContact.fields.middle_name.value,
    last: state.addOrEditContact.fields.last_name.value,
    phone: state.addOrEditContact.fields.phones[0].value,
    email: state.addOrEditContact.fields.email[0].value,
    conversationSelected: state.inbox.conversationSelected,
    newConversationSelected: state.inbox.newConversationSelected,
  }),
  null,
)(
  withStyles((theme) => ({
    name: {
      color: '#707070',
      fontWeight: 'bold',
      fontSize: 23,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  }))(
    ({
      first,
      middle,
      last,
      phone,
      email,
      classes,
      conversationSelected,
      newConversationSelected,
    }) => (
      <div className={classes.name}>
        {conversationSelected || newConversationSelected
          ? first || middle || last
            ? `${first ? `${first} ` : ''}${middle ? `${middle} ` : ''}${
                last ? `${last} ` : ''
              }`
            : phone
            ? phone
            : email
            ? email
            : ''
          : 'Select a conversation'}
      </div>
    ),
  ),
)

const ChatSearch = connect(
  (state) => ({ value: state.inbox.conversationSearch.search }),
  (dispatch) =>
    bindActionCreators(
      { toggleChatSearch, handleSearchOptionsChange },
      dispatch,
    ),
)(
  withStyles((theme) => ({
    input: {
      fontSize: 16,
      borderWidth: 0,
      width: '100%',
      '&:focus': {
        outline: 'none',
      },
      marginTop: 18,
    },
  }))(
    class ChatSearchComponent extends Component {
      componentDidMount() {
        this.searchInput.focus()
      }

      render() {
        return (
          <input
            value={this.props.value}
            onChange={(e) =>
              this.props.handleSearchOptionsChange('search', e.target.value)
            }
            ref={(input) => {
              this.searchInput = input
            }}
            type="text"
            placeholder="Search this chat..."
            className={this.props.classes.input}
            onBlur={() => {
              if (!this.props.value) {
                this.props.toggleChatSearch(false)
              }
            }}
          />
        )
      }
    },
  ),
)

const BackButton = connect(
  (state) => ({ contactSearch: state.inbox.contactSearch }),
  (dispatch) =>
    bindActionCreators({ toggleThreadView, selectConversation }, dispatch),
)(
  withStyles((theme) => ({
    button: {
      position: 'absolute',
      left: 2,
      top: 25,
      padding: 0,
      color: theme.palette.secondary.main,
    },
  }))(
    ({ classes, toggleThreadView, selectConversation, contactSearch }) =>
      contactSearch === null && (
        <IconButton
          onClick={() => {
            toggleThreadView()
            selectConversation(null)
          }}
          className={classes.button}
        >
          <KeyboardArrowLeft />
        </IconButton>
      ),
  ),
)

export default connect(
  (state) => ({
    chatSearchVisible: state.inbox.chatSearchVisible,
    contactSearch: state.inbox.contactSearch,
    conversationSelected: state.inbox.conversationSelected,
    newConversationSelected: state.inbox.newConversationSelected,
  }),
  (dispatch) =>
    bindActionCreators(
      { toggleContactViewPanel, toggleChatSearch, read },
      dispatch,
    ),
)(
  withStyles((theme) => ({
    contactSummary: {
      height: 75,
      boxShadow: `0px 5px 10px #d3d3d354`,
      padding: '7.5px 110px 7.5px 82.5px',
      position: 'relative',
      maxWidth: '100vw',
      [theme.breakpoints.down('sm')]: {
        padding: '7.5px 110px 7.5px 90.5px',
      },
    },
    refreshButton: {
      color: '#c2c2c2',
      position: 'absolute',
      top: 12,
      right: 100,
      padding: 5,
    },
    searchButton: {
      color: '#c2c2c2',
      position: 'absolute',
      top: 12,
      right: 53,
      padding: 5,
    },
    icon: {
      width: 40,
      height: 40,
    },
  }))(
    ({
      classes,
      toggleContactViewPanel,
      toggleChatSearch,
      chatSearchVisible,
      contactSearch,
      conversationSelected,
      newConversationSelected,
      read,
    }) => (
      <div className={classes.contactSummary}>
        <Hidden mdUp>
          <BackButton />
        </Hidden>
        {typeof contactSearch !== 'string' ? <SummaryAvatar /> : null}
        {chatSearchVisible ? (
          <ChatSearch />
        ) : (
          <div style={{ paddingTop: 4 }}>
            <SummaryName />
            {conversationSelected || newConversationSelected ? (
              <Fragment>
                <Hidden smDown>
                  <Button
                    style={{
                      color: '#c3c3c3',
                      textTransform: 'none',
                      padding: 2,
                    }}
                    onClick={() => toggleContactViewPanel(true)}
                  >
                    <RemoveRedEye style={{ marginRight: 5 }} />
                    View this contact
                  </Button>
                </Hidden>
                <Hidden mdUp>
                  <Button
                    component={Link}
                    to={`/contacts/${
                      conversationSelected || newConversationSelected
                    }`}
                    style={{
                      color: '#c3c3c3',
                      textTransform: 'none',
                      padding: 2,
                    }}
                    onClick={() => toggleContactViewPanel(true)}
                  >
                    <RemoveRedEye style={{ marginRight: 5 }} />
                    View this contact
                  </Button>
                </Hidden>
              </Fragment>
            ) : null}
          </div>
        )}
        {/*typeof contactSearch !== 'string' && conversationSelected ? (
          <Tooltip title="Refresh this conversation">
            <IconButton
              className={classes.refreshButton}
              onClick={() =>
                read(
                  conversationSelected,
                  'inbox',
                  'inbox/conversation',
                  'contact_id',
                )
              }
              disabled={chatSearchVisible}
            >
              <Refresh className={classes.icon} />
            </IconButton>
          </Tooltip>
        ) : null*/}
        {typeof contactSearch !== 'string' && conversationSelected ? (
          <Tooltip title="Search this chat">
            <IconButton
              className={classes.searchButton}
              onClick={() => toggleChatSearch()}
              disabled={chatSearchVisible}
            >
              <Search className={classes.icon} />
            </IconButton>
          </Tooltip>
        ) : null}
        {typeof contactSearch !== 'string' && conversationSelected ? (
          <SearchOptionsMenu />
        ) : null}
      </div>
    ),
  ),
)
